var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sign-in"},[_c('b-row',{staticClass:"no-gutters sign-in-wrapper"},[_c('div',{staticClass:"sign-in-efinop-logo"},[_c('img',{attrs:{"src":_vm.logo,"alt":"background","width":"60","height":"60"}}),_c('span',[_vm._v("eFINOP")])]),_c('div',{staticClass:"sign-in-view"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }